import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, normalizeStyle as _normalizeStyle, createVNode as _createVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import { Ref, computed, ref } from 'vue';
import RexTooltipV3 from '@/rex-components/RexTooltipV3.vue';
import { CaretUpOutlined, CaretDownOutlined } from '@ant-design/icons-vue';
import { useThemeToken } from '@/utils/theme/useThemeToken';
import { useI18n } from 'vue-i18n';


export default /*#__PURE__*/_defineComponent({
  __name: 'RexSortFieldV3',
  emits: ['onSortChange'],
  setup(__props, { emit: __emit }) {

const emit = __emit;
const { t } = useI18n();
const { token } = useThemeToken();
const currState: Ref<boolean | null> = ref(null);

function onSortFieldClick() {
  currState.value =
    currState.value == null ? true : currState.value == true ? false : null;
  emit('onSortChange', currState.value);
}

const getAscIconColor = computed(() =>
  currState.value === true
    ? token.value?.colorPrimary
    : 'rgba(255, 255, 255, 0.7)',
);

const getDescIconColor = computed(() =>
  currState.value === false
    ? token.value?.colorPrimary
    : 'rgba(255, 255, 255, 0.7)',
);

const getTooltipText = computed(() => {
  return currState.value === true
    ? t('clickToSortDesc')
    : currState.value === false
      ? t('clickToCancelSorting')
      : t('clickToSortAsc');
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(RexTooltipV3, {
    title: getTooltipText.value,
    color: '',
    overlayInnerStyle: { fontSize: '0.85rem' }
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", {
        class: "rex-sort-field-box",
        onClick: onSortFieldClick
      }, [
        _createVNode(_unref(CaretUpOutlined), {
          style: _normalizeStyle({
          height: '0.55rem',
          color: getAscIconColor.value,
        })
        }, null, 8, ["style"]),
        _createVNode(_unref(CaretDownOutlined), {
          style: _normalizeStyle({
          height: '0.55rem',
          color: getDescIconColor.value,
        })
        }, null, 8, ["style"])
      ])
    ]),
    _: 1
  }, 8, ["title"]))
}
}

})